// eslint-disable-next-line no-shadow
export const enum VanityDomainStatus {
  Pending,
  ValidationFailed,
  Active,
}
